import React from "react";

const AlumniCard = ({
  image,
  name,
  university,
  scholarship,
  frameClass,
  topBadgeClass,
  bottomBadgeClass,
  imageZoom = 1,
  imageZoomTablet,
  imageZoomMobile,
  imagePositionX = "center",
  imagePositionXTablet,
  imagePositionXMobile,
  imageTranslateY = "0px",
  imageTranslateYTablet,
  imageTranslateYMobile,
}) => (
  <article className={`relative w-32 shrink-0 rounded-[20px] p-2 shadow-[0_10px_24px_rgba(32,42,96,0.2)] sm:w-40 lg:w-44 ${frameClass}`}>
    <div className="relative overflow-hidden rounded-2xl bg-white">
      <img
        src={image}
        alt={`${name} alumni`}
        className="h-40 w-full rounded-2xl object-cover translate-y-[var(--alumni-translate-y-mobile)] md:translate-y-[var(--alumni-translate-y-tablet)] xl:translate-y-[var(--alumni-translate-y-desktop)] scale-[var(--alumni-scale-mobile)] md:scale-[var(--alumni-scale-tablet)] xl:scale-[var(--alumni-scale-desktop)] [object-position:var(--alumni-pos-x-mobile)_center] md:[object-position:var(--alumni-pos-x-tablet)_center] xl:[object-position:var(--alumni-pos-x-desktop)_center] sm:h-48 lg:h-56"
        style={{
          "--alumni-scale-mobile": imageZoomMobile ?? imageZoom,
          "--alumni-scale-tablet": imageZoomTablet ?? imageZoom,
          "--alumni-scale-desktop": imageZoom,
          "--alumni-pos-x-mobile": imagePositionXMobile ?? imagePositionX,
          "--alumni-pos-x-tablet": imagePositionXTablet ?? imagePositionX,
          "--alumni-pos-x-desktop": imagePositionX,
          "--alumni-translate-y-mobile": imageTranslateYMobile ?? imageTranslateY,
          "--alumni-translate-y-tablet": imageTranslateYTablet ?? imageTranslateY,
          "--alumni-translate-y-desktop": imageTranslateY,
          transformOrigin: "center center",
        }}
        loading="lazy"
        decoding="async"
        width="192"
        height="240"
      />
    </div>
    <div
      className={`absolute -top-3 left-3 right-3 rounded-full px-3 py-1 text-center text-[10px] font-semibold leading-tight text-[#202A60] sm:text-[11px] ${topBadgeClass}`}
    >
      <p>{name}</p>
      <p>{university}</p>
    </div>
    <p
      className={`absolute -bottom-2 left-3 right-3 rounded-full px-2 py-1 text-center text-[10px] font-semibold text-white ${bottomBadgeClass}`}
    >
      {scholarship}
    </p>
  </article>
);

export default AlumniCard;
